import { useEffect } from 'react'
import useStores from '@stores/useStores'

const useCustomization = () => {
  const { surveyState } = useStores()

  useEffect(() => {
    if (surveyState.hasBrandColor) setColors(surveyState.customization.brand_color)
  }, [surveyState.hasBrandColor])

  const setColors = brandColor => {
    const root = document.documentElement
    root.style.setProperty('--color1', brandColor)
    root.style.setProperty('--color1-dark', surveyState.customization.brand_color)
    root.style.setProperty('--color2', surveyState.brandColorDark)
    root.style.setProperty('--button-bg', '#FCFCFD')
    root.style.setProperty('--button-border', '110, 111, 128')
    root.style.setProperty('--button-color', '110, 111, 128')
  }
}

export default useCustomization
